import Vue from "vue";
import VueOnToast from "vue-on-toast";
Vue.use(VueOnToast);
